<template>
  <div class="wrapp">
    <button @click="$router.back()" class="btn btn-primary goback">
      <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
      {{ $t('previewPage.back') }}
    </button>
    <button
      style="
        font-size: 2.3rem;
        color: #4ce595;
        margin-left: 1rem;
        margin-top: 0rem;
        border: none;
      "
      @click="exportPdfResearch()"
    >
      <i class="fas fa-file-pdf"></i>
    </button>

    <div id="div-print">
      <div v-if="displayClosingMessage" class="container">
        <div class="pt-2" v-if="action.enableTranslation">
          <b-button-group>
            <b-button
              v-if="action.email.template.enableMyHTMLPt"
              class="btn"
              @click="setLangView('br')"
              :variant="langView === 'br' ? 'primary' : ''"
              ><country-flag country="br" size="normal"
            /></b-button>
            <b-button
              v-if="action.email.template.enableMyHTMLEn"
              class="btn"
              @click="setLangView('us')"
              :variant="langView === 'us' ? 'primary' : ''"
              ><country-flag country="us" size="normal"
            /></b-button>
            <b-button
              v-if="action.email.template.enableMyHTMLEs"
              class="btn"
              @click="setLangView('es')"
              :variant="langView === 'es' ? 'primary' : ''"
              ><country-flag country="es" size="normal"
            /></b-button>
          </b-button-group>
        </div>

        <div v-if="action.closingMessageEnabled && closingMessage.html">
          <div v-if="closingMessage.useLogo" class="row">
            <div class="col-12 mt-3">
              <div class="text-center">
                <img :src="logo" style="height: 75px; max-width: 100%" />
              </div>
            </div>
          </div>

          <div class="row">
            <div
              class="col-12 mb-4 mt-4 closing-message-area"
              v-html="closingMessage.html"
            />
          </div>
        </div>

        <div v-else class="row">
          <div class="col-12 text-center mt-4 closing-message-area">
            <span><i class="far fa-smile"></i></span>
            <h4 class="mt-4">
              {{ $t('previewPage.title') }}
            </h4>
            <span>
              {{ $t('previewPage.firstMsg') }}
            </span>
            <span>
              {{ $t('previewPage.secondMsg') }}
            </span>
          </div>
        </div>
      </div>

      <div
        v-else
        class="container"
        :style="{
          backgroundColor:
            action.email.template.scale !== 'colors'
              ? action.email.template.background
              : '#ffffff',
        }"
      >
        <div class="pt-2" v-if="action.enableTranslation">
          <b-button-group>
            <b-button
              v-if="action.email.template.enableMyHTMLPt"
              class="btn"
              @click="setLangView('br')"
              :variant="langView === 'br' ? 'primary' : ''"
              ><country-flag country="br" size="normal"
            /></b-button>
            <b-button
              v-if="action.email.template.enableMyHTMLEn"
              class="btn"
              @click="setLangView('us')"
              :variant="langView === 'us' ? 'primary' : ''"
              ><country-flag country="us" size="normal"
            /></b-button>
            <b-button
              v-if="action.email.template.enableMyHTMLEs"
              class="btn"
              @click="setLangView('es')"
              :variant="langView === 'es' ? 'primary' : ''"
              ><country-flag country="es" size="normal"
            /></b-button>
          </b-button-group>
        </div>
        <div v-if="action.useLogo" class="row">
          <div class="col-12 mt-4">
            <div class="logo-area text-center">
              <img :src="logo" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div
              id="body-email"
              class="mt-3 mb-4 html-content"
              v-html="myHTML"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="text-center">
              <template v-if="!questionHTML">
                {{ question }}
              </template>
              <template v-else>
                <div v-html="questionHTML"></div>
              </template>
            </div>
            <methodology
              :lang="langView"
              :surveySelectedColor="
                action.email.template.templatebuttonselected
              "
              :templateColor="this.action.email.template.scale || 'colors'"
              :actionMetric="action.type"
              class="mt-4 mb-3"
            />
          </div>
        </div>

        <div v-if="action.commentPosition === 'up'" class="row mb-4">
          <div class="col-12">
            <div class="feedback-area mt-3">
              <template v-if="langView === 'br' || !langView">
                <research-replys
                  v-if="!action.feedbackDisabled"
                  :style="{
                    color:
                      action.email.template.scale !== 'colors'
                        ? action.email.template.backgroundtext
                        : '#000000',
                  }"
                  :metric="action.type"
                  :promotersReply="action.reply.promoters"
                  :neutralReply="action.reply.neutral"
                  :detractorsReply="action.reply.detractors"
                  :grade="testNpsReview"
                />
              </template>

              <template v-if="langView === 'us'">
                <research-replys
                  v-if="!action.feedbackDisabled"
                  :defaultFeedback="'What is the main reason for your grade?'"
                  :style="{
                    color:
                      action.email.template.scale !== 'colors'
                        ? action.email.template.backgroundtext
                        : '#000000',
                  }"
                  :metric="action.type"
                  :promotersReply="(action.reply.promoters) ? action.reply.languageSupport.promotersEN : null"
                  :neutralReply="(action.reply.neutral) ? action.reply.languageSupport.neutralEN : null"
                  :detractorsReply="(action.reply.detractors) ? action.reply.languageSupport.detractorsEN : null"
                  :grade="testNpsReview"
                />
              </template>

              <template v-if="langView === 'es'">
                <research-replys
                  v-if="!action.feedbackDisabled"
                  :defaultFeedback="'¿Cuál es la razón principal de tu calificación?'"
                  :style="{
                    color:
                      action.email.template.scale !== 'colors'
                        ? action.email.template.backgroundtext
                        : '#000000',
                  }"
                  :metric="action.type"
                  :promotersReply="(action.reply.promoters) ? action.reply.languageSupport.promotersES : null"
                  :neutralReply="(action.reply.neutral) ? action.reply.languageSupport.neutralES : null"
                  :detractorsReply="(action.reply.detractors) ? action.reply.languageSupport.detractorsES : null"
                  :grade="testNpsReview"
                />
              </template>
              <textarea v-if="!action.feedbackDisabled" name="" id="feedback" class="form-control"></textarea>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <hr v-if="action.email.additionalQuestions.length > 0" />
            <div v-for="(item, i) in action.email.additionalQuestions" :key="i">
              <!-- pergunta condicional -->
              <template v-if="item.profileEnabled">
                <template
                  v-if="
                    item.selectedProfile &&
                    item.selectedProfile.includes(conditionalQuestion())
                  "
                >
                  <template
                    v-if="
                      promotersGrades.includes(testNpsReview) ||
                      detractorsGrades.includes(testNpsReview) ||
                      passivesGrades.includes(testNpsReview)
                    "
                  >
                    <likert
                      v-if="item.type === 'LIKERT' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :lang="action.multiLanguage ? langView : $i18n.locale"
                      :text="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :item-id="i.toString()"
                      :index="i"
                      :colorTemplate="action.email.template.scale"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      :template="item.template"
                      @input="getReview"
                      :idQuestion="item.id"
                    />

                    <c-sat
                      v-if="item.type === 'CSAT' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :item-id="i.toString()"
                      :index="i"
                      :colorTemplate="action.email.template.scale"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      :template="item.template"
                      @input="getReview"
                      :idQuestion="item.id"
                      :lang="action.multiLanguage ? langView : $i18n.locale"
                    />

                    <star-rating
                      v-if="item.type === 'REVIEWS' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :item-id="i.toString()"
                      :index="i"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      @input="getReview"
                      :idQuestion="item.id"
                      :lang="action.multiLanguage ? langView : $i18n.locale"
                    />

                    <like-dislike
                      v-if="item.type === 'LIKE/DISLIKE' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :questionText="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :index="i"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      :reviewAnswer="-99"
                      @input="getReview"
                      :idQuestion="item.id"
                      :item-id="i.toString()"
                      :lang="action.multiLanguage ? langView : $i18n.locale"
                    />

                    <emotion
                      v-if="item.type === 'EMOTION' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :questionText="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :index="i"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      :reviewAnswer="-99"
                      @input="getReview"
                      :idQuestion="item.id"
                      :item-id="i.toString()"
                      :lang="action.multiLanguage ? langView : $i18n.locale"
                    />

                    <multiple-choices
                      v-if="
                        item.type === 'MULTIPLE' &&
                        item.template !== 'withSubOptions'
                        && !item.show && !item.display
                      "
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :type="item.multipleType"
                      :choices="item.choices"
                      :index="i"
                      :commentEnabled="item.commentEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      :questionText="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :lang="langView"
                      @input="getReview"
                      :template="item.template"
                      :item-id="i.toString()"
                      :pageBackground="action.email.template.scale !== 'colors' ? action.email.template.background : ''"
                      :idQuestion="item.id"
                      :limitChoices="item.maximumAmountSelection"
                    />

                    <multiple-choices-custom
                      v-if="
                        item.type === 'MULTIPLE' &&
                        item.template === 'withSubOptions'
                        && !item.show && !item.display
                      "
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :type="item.multipleType"
                      :choices="item.choices"
                      :index="i"
                      :commentEnabled="item.commentEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      :questionText="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :lang="langView"
                      @input="getReview"
                      :item-id="i.toString()"
                      :idQuestion="item.id"
                      :limitChoices="item.maximumAmountSelection"
                    />

                    <ces
                      v-if="item.type === 'CES' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :item-id="i.toString()"
                      :index="i"
                      :colorTemplate="action.email.template.scale"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      @input="getReview"
                      :idQuestion="item.id"
                      :lang="action.multiLanguage ? langView : $i18n.locale"
                    />

                    <input-type
                      v-if="item.type === 'INPUT' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :index="i"
                      :addQuestionTemplate="addQuestionTemplate"
                      @input="getReview"
                      :placeholder="
                        langView === 'br'
                          ? 'Preencha aqui'
                          : langView === 'us'
                          ? 'Write here'
                          : 'Escribe aquí'
                      "
                      :idQuestion="item.id"
                      :item-id="i.toString()"
                    />

                    <input-type-cpf
                      v-if="item.type === 'INPUT-CPF' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :index="i"
                      :addQuestionTemplate="addQuestionTemplate"
                      @input="getReview"
                      :placeholder="
                        langView === 'br'
                          ? 'Preencha aqui'
                          : langView === 'us'
                          ? 'Write here'
                          : 'Escribe aquí'
                      "
                      :idQuestion="item.id"
                      :item-id="i.toString()"
                    />

                    <nps
                      v-if="item.type === 'NPS' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :item-id="i.toString()"
                      :index="i"
                      :colorTemplate="action.email.template.scale"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      :template="item.template"
                      @input="getReview"
                      :idQuestion="item.id"
                      :lang="action.multiLanguage ? langView : $i18n.locale"
                    />

                    <likertEmotion
                      v-if="item.type === 'LIKERT/EMOTION' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :text="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :item-id="i.toString()"
                      :index="i"
                      :colorTemplate="action.email.template.scale"
                      :commentEnabled="item.commentEnabled"
                      :applicableEnabled="item.applicableEnabled"
                      :addQuestionTemplate="addQuestionTemplate"
                      @input="getReview"
                      :idQuestion="item.id"
                      :lang="action.multiLanguage ? langView : $i18n.locale"
                    />

                    <label-question
                      v-if="item.type === 'LABEL' && !item.show && !item.display"
                      :textColor="
                        action.email.template.scale !== 'colors'
                          ? action.email.template.backgroundtext
                          : '#000000'
                      "
                      :addQuestionTemplate="addQuestionTemplate"
                      :item-id="i.toString()"
                      :text="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :idQuestion="item.id"
                      :index="i"
                    />
                  </template>
                </template>
              </template>
              <template v-else>
                <likert
                  v-if="item.type === 'LIKERT' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :lang="action.multiLanguage ? langView : $i18n.locale"
                  :text="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :item-id="i.toString()"
                  :index="i"
                  :colorTemplate="action.email.template.scale"
                  :commentEnabled="item.commentEnabled"
                  :applicableEnabled="item.applicableEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  :idQuestion="item.id"
                  @input="getReview"
                  :template="item.template"
                />

                <nps
                  v-if="item.type === 'NPS' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :text="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :item-id="i.toString()"
                  :index="i"
                  :colorTemplate="action.email.template.scale"
                  :commentEnabled="item.commentEnabled"
                  :applicableEnabled="item.applicableEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  :idQuestion="item.id"
                  @input="getReview"
                  :template="item.template"
                  :lang="action.multiLanguage ? langView : $i18n.locale"
                />

                <c-sat
                  v-if="item.type === 'CSAT' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :text="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :item-id="i.toString()"
                  :index="i"
                  :colorTemplate="action.email.template.scale"
                  :commentEnabled="item.commentEnabled"
                  :applicableEnabled="item.applicableEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  :idQuestion="item.id"
                  @input="getReview"
                  :template="item.template"
                  :lang="action.multiLanguage ? langView : $i18n.locale"
                />

                <star-rating
                  v-if="item.type === 'REVIEWS' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :text="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :item-id="i.toString()"
                  :index="i"
                  :commentEnabled="item.commentEnabled"
                  :applicableEnabled="item.applicableEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  :idQuestion="item.id"
                  @input="getReview"
                  :lang="action.multiLanguage ? langView : $i18n.locale"
                />

                <like-dislike
                  v-if="item.type === 'LIKE/DISLIKE' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :questionText="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :index="i"
                  :item-id="i.toString()"
                  :commentEnabled="item.commentEnabled"
                  :applicableEnabled="item.applicableEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  :idQuestion="item.id"
                  @input="getReview"
                  :reviewAnswer="-99"
                  :lang="action.multiLanguage ? langView : $i18n.locale"
                />

                <emotion
                  v-if="item.type === 'EMOTION' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :questionText="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :index="i"
                  :item-id="i.toString()"
                  :commentEnabled="item.commentEnabled"
                  :applicableEnabled="item.applicableEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  :idQuestion="item.id"
                  @input="getReview"
                  :reviewAnswer="-99"
                  :lang="action.multiLanguage ? langView : $i18n.locale"
                />

                <multiple-choices
                  v-if="
                    item.type === 'MULTIPLE' &&
                    item.template !== 'withSubOptions' &&
                    !item.show && !item.display
                  "
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :type="item.multipleType"
                  :choices="item.choices"
                  :index="i"
                  :item-id="i.toString()"
                  :commentEnabled="item.commentEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  :idQuestion="item.id"
                  @input="getReview"
                  :questionText="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :lang="langView"
                  :template="item.template"
                  :pageBackground="action.email.template.scale !== 'colors' ? action.email.template.background : ''"
                  :limitChoices="item.maximumAmountSelection"
                />

                <multiple-choices-custom
                  v-if="
                    item.type === 'MULTIPLE' &&
                    item.template === 'withSubOptions' &&
                    !item.show && !item.display
                  "
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :type="item.multipleType"
                  :choices="item.choices"
                  :index="i"
                  :item-id="i.toString()"
                  :commentEnabled="item.commentEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  :idQuestion="item.id"
                  @input="getReview"
                  :questionText="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :lang="langView"
                  :template="item.template"
                  :limitChoices="item.maximumAmountSelection"
                />

                <ces
                  v-if="item.type === 'CES' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :text="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :item-id="i.toString()"
                  :index="i"
                  :colorTemplate="action.email.template.scale"
                  :commentEnabled="item.commentEnabled"
                  :applicableEnabled="item.applicableEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  :idQuestion="item.id"
                  @input="getReview"
                  :lang="action.multiLanguage ? langView : $i18n.locale"
                />

                <input-type
                  v-if="item.type === 'INPUT' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :text="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :item-id="i.toString()"
                  :index="i"
                  :addQuestionTemplate="addQuestionTemplate"
                  :placeholder="
                    langView === 'br'
                      ? 'Preencha aqui'
                      : langView === 'us'
                      ? 'Write here'
                      : 'Escribe aquí'
                  "
                  :idQuestion="item.id"
                />

                <input-type-cpf
                  v-if="item.type === 'INPUT-CPF' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :text="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :item-id="i.toString()"
                  :index="i"
                  :addQuestionTemplate="addQuestionTemplate"
                  :placeholder="
                    langView === 'br'
                      ? 'Preencha aqui'
                      : langView === 'us'
                      ? 'Write here'
                      : 'Escribe aquí'
                  "
                  :idQuestion="item.id"
                />

                <likertEmotion
                  v-if="item.type === 'LIKERT/EMOTION' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :text="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :item-id="i.toString()"
                  :index="i"
                  :applicableEnabled="item.applicableEnabled"
                  :commentEnabled="item.commentEnabled"
                  :addQuestionTemplate="addQuestionTemplate"
                  @input="getReview"
                  :idQuestion="item.id"
                  :lang="action.multiLanguage ? langView : $i18n.locale"
                />

                <label-question
                  v-if="item.type === 'LABEL' && !item.show && !item.display"
                  :textColor="
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000'
                  "
                  :addQuestionTemplate="addQuestionTemplate"
                  :item-id="i.toString()"
                  :text="
                    langView === 'br'
                      ? item.text
                      : langView === 'us'
                      ? item.textEN
                      : item.textES
                  "
                  :idQuestion="item.id"
                />

                <template
                  v-if="
                    action.email.additionalQuestions[i].displayType ===
                      'formSearch' && !item.show && !item.display
                  "
                >
                  <contact
                    v-if="item.type === 'CONTACT' && !item.show"
                    :textColor="
                      action.email.template.scale !== 'colors'
                        ? action.email.template.backgroundtext
                        : '#000000'
                    "
                    :type="item.displayType"
                    :questionText="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :choices="item.choices"
                    :index="i"
                    :addQuestionTemplate="addQuestionTemplate"
                    :lang="langView"
                    :idQuestion="item.id"
                    :item-id="i.toString()"
                  />
                </template>
              </template>
            </div>
          </div>
        </div>

        <div v-if="action.commentPosition === 'down'" class="row">
          <div class="col-12">
            <div class="feedback-area mt-3">
              <template v-if="langView === 'br' || !langView">
                <research-replys
                  v-if="!action.feedbackDisabled"
                  :style="{
                    color:
                      action.email.template.scale !== 'colors'
                        ? action.email.template.backgroundtext
                        : '#000000',
                  }"
                  :metric="action.type"
                  :promotersReply="action.reply.promoters"
                  :neutralReply="action.reply.neutral"
                  :detractorsReply="action.reply.detractors"
                  :grade="testNpsReview"
                />
              </template>

              <template v-if="langView === 'us'">
                <research-replys
                  v-if="!action.feedbackDisabled"
                  :defaultFeedback="'What is the main reason for your grade?'"
                  :style="{
                    color:
                      action.email.template.scale !== 'colors'
                        ? action.email.template.backgroundtext
                        : '#000000',
                  }"
                  :metric="action.type"
                  :promotersReply="(action.reply.promoters) ? action.reply.languageSupport.promotersEN : null"
                  :neutralReply="(action.reply.neutral) ? action.reply.languageSupport.neutralEN : null"
                  :detractorsReply="(action.reply.detractors) ? action.reply.languageSupport.detractorsEN : null"
                  :grade="testNpsReview"
                />
              </template>

              <template v-if="langView === 'es'">
                <research-replys
                  v-if="!action.feedbackDisabled"
                  :defaultFeedback="'¿Cuál es la razón principal de tu calificación?'"
                  :style="{
                    color:
                      action.email.template.scale !== 'colors'
                        ? action.email.template.backgroundtext
                        : '#000000',
                  }"
                  :metric="action.type"
                  :promotersReply="(action.reply.promoters) ? action.reply.languageSupport.promotersES : null"
                  :neutralReply="(action.reply.neutral) ? action.reply.languageSupport.neutralES : null"
                  :detractorsReply="(action.reply.detractors) ? action.reply.languageSupport.detractorsES : null"
                  :grade="testNpsReview"
                />
              </template>

              <textarea v-if="!action.feedbackDisabled" name="" id="feedback" class="form-control"></textarea>
            </div>
          </div>
        </div>

        <div class="pt-2 row" v-if="action.enableAnonymous">
          <b-form-checkbox
            :checked="action.allAnswersAnonymous"
            class="check-alert-modal ml-3"
            disabled
            id="id-anonymous"
          >
          </b-form-checkbox>
          <label
            for="id-anonymous"
            class="pl-20"
            :style="{
              color:
                action.email.template.scale !== 'colors'
                  ? action.email.template.backgroundtext
                  : '#000000',
            }"
            v-show="langView === 'br'"
          >
            {{ action.enableAnonymous }}
          </label>
          <label
            for="id-anonymous"
            class="pl-20"
            :style="{
              color:
                action.email.template.scale !== 'colors'
                  ? action.email.template.backgroundtext
                  : '#000000',
            }"
            v-show="langView === 'us'"
          >
            {{ action.enableAnonymousEn }}
          </label>
          <label
            for="id-anonymous"
            class="pl-20"
            :style="{
              color:
                action.email.template.scale !== 'colors'
                  ? action.email.template.backgroundtext
                  : '#000000',
            }"
            v-show="langView === 'es'"
          >
            {{ action.enableAnonymousEs }}
          </label>
        </div>

        <div class="row mt-5">
          <div class="col-12 text-center btn-send">
            <template v-if="typeModalContact">
              <modalContact />
            </template>

            <template v-else>
              <div v-if="action.submitButtonEnabled">
                <button
                  @click="handleClosingMessage"
                  :style="{
                    boxShadow: `0px 10px 30px -7px ${
                      action.email.template.buttonColor || '#cccccc'
                    }`,
                    backgroundColor: action.email.template.buttonColor
                      ? action.email.template.buttonColor
                      : '',
                    borderColor: action.email.template.buttonBorderColor
                      ? action.email.template.buttonBorderColor
                      : '',
                    color: action.email.template.buttonTextColor
                      ? action.email.template.buttonTextColor
                      : '',
                  }"
                  type="button"
                  class="btn btn-primary px-5 py-2 btn-shadow"
                >
                  <span v-show="langView === 'br'">
                    {{
                      action.email.template.submitButtonValue ||
                      $t('researchPage.send')
                    }}
                  </span>
                  <span v-show="langView === 'us'">
                    {{
                      action.email.template.submitButtonValueEn ||
                      $t('researchPage.send')
                    }}
                  </span>
                  <span v-show="langView === 'es'">
                    {{
                      action.email.template.submitButtonValueEs ||
                      $t('researchPage.send')
                    }}
                  </span>
                </button>
              </div>
              <div v-else>
                <button
                  @click="handleClosingMessage"
                  type="button"
                  class="btn btn-primary px-5 py-2 btn-shadow"
                >
                  {{ $t('previewPage.send') }}
                </button>
              </div>
            </template>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center mt-4">
            <hr />
            <div
              class="template-footer-modal mt-4"
              v-if="action.email.template.footer"
            >
              <img src="../../../assets/logo-indecx.png" style="width: 80px" />
            </div>
          </div>
        </div>

        <div v-if="action.privacyPolicy" class="row">
          <div class="col-12 text-center">
            <span style="font-size: 0.9em" v-show="langView === 'br'"
              ><a
                :style="{
                  color:
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#212529',
                }"
                :href="company.privacyPolicy"
                target="_blank"
                >{{ action.privacyPolicy }}</a
              ></span
            >
            <span style="font-size: 0.9em" v-show="langView === 'us'"
              ><a
                :href="company.privacyPolicy"
                :style="{
                  color:
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000',
                }"
                target="_blank"
                >{{ action.privacyPolicyEn }}</a
              ></span
            >
            <span style="font-size: 0.9em" v-show="langView === 'es'"
              ><a
                :href="company.privacyPolicy"
                :style="{
                  color:
                    action.email.template.scale !== 'colors'
                      ? action.email.template.backgroundtext
                      : '#000000',
                }"
                target="_blank"
                >{{ action.privacyPolicyEs }}</a
              ></span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JsPdf from 'jspdf';
import Html2canvas from 'html2canvas';
import CountryFlag from 'vue-country-flag';
import { mapState } from 'vuex';
import nps from '@/components/molecules/metrics/nps';
import cSat from '@/components/molecules/metrics/csat';
import ces from '@/components/molecules/metrics/ces';
import likert from '@/components/molecules/metrics/likert';
import starRating from '@/components/molecules/metrics/reviews';
import likeDislike from '@/components/molecules/metrics/like-dislike';
import emotion from '@/components/molecules/metrics/emotion';
import multipleChoices from '@/components/molecules/metrics/multiple-choices';
import multipleChoicesCustom from '@/components/molecules/metrics/multiple-choices-custom';
import inputType from '@/components/molecules/metrics/input-type';
import inputTypeCpf from '@/components/molecules/metrics/input-type-cpf';
import labelQuestion from '@/components/molecules/metrics/label-question';
import contact from '@/components/molecules/metrics/contact';
import methodology from '@/components/molecules/action-templates/methodology';
import researchReplys from '@/components/atoms/research-replys';
import modalContact from '@/components/molecules/modal-contact';
import likertEmotion from '@/components/molecules/metrics/likert-emotion';
import EventBus from '../../../eventBus';

export default {
  components: {
    nps,
    cSat,
    likert,
    starRating,
    likeDislike,
    emotion,
    multipleChoices,
    inputType,
    labelQuestion,
    contact,
    methodology,
    researchReplys,
    modalContact,
    ces,
    CountryFlag,
    likertEmotion,
    inputTypeCpf,
    multipleChoicesCustom,
  },

  data: () => ({
    userAuth: null,
    action: null,
    displayClosingMessage: false,
    actionClosingMessage: null,
    closingMessage: {
      useLogo: false,
      html: null,
    },
    logo: null,
    linkprivacyPolicy: null,
    apiRoot: null,
    selected: 'anonymous',
    showModal: false,
    typeModalContact: false,
    promotersGrades: [5, 4],
    passivesGrades: [3],
    detractorsGrades: [2, 1],
    addQuestionTemplate: 'default',
    review: null,
    exists: null,
    questionsRemoved: [],
    question: null,
    questionHTML: null,
    myHTML: null,
    langView: null,
  }),

  computed: {
    ...mapState('actions', ['testNpsReview']),
    ...mapState('companies', ['company']),
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.action = JSON.parse(localStorage.getItem('_indecx_action'));
    this.actionClosingMessage = JSON.parse(
      localStorage.getItem('_indecx_action_closing_message'),
    );

    this.addQuestionTemplate = this.action.addQuestionTemplate;

    this.apiRoot = process.env.API_ROOT;

    EventBus.$on('showClossingMessage', (value) => {
      this.displayClosingMessage = value;
    });

    for (let i = 0; i < this.action.email.additionalQuestions.length; i += 1) {
      if (this.action.email.additionalQuestions[i].type === 'CONTACT') {
        if (
          this.action.email.additionalQuestions[i].displayType ===
          'afterSendAnswer'
        ) {
          this.typeModalContact = true;
        }
      }

      if (this.action.email.additionalQuestions[i].type === 'MULTIPLE') {
        if (this.action.email.additionalQuestions[i].isRandomizeQuestionOrder) {
          this.shuffleArray(this.action.email.additionalQuestions[i].choices);
          const choices = this.action.email.additionalQuestions[i].choices;
          if (choices.length > 0) {
            for (let j = 0; j < choices.length; j += 1) {
              if (choices[j].subChoices && choices[j].subChoices.length > 0) {
                this.shuffleArray(choices[j].subChoices);
              }
            }
          }
        }
      }
    }

    if (this.action.type.includes('0-10')) {
      this.promotersGrades = [10, 9];
      this.passivesGrades = [8, 7];
      this.detractorsGrades = [6, 5, 4, 3, 2, 1, 0];
    }

    if (this.action.type === 'like-dislike') {
      this.promotersGrades = [1];
      this.detractorsGrades = [0];
    }

    const logoUrl = process.env.INDECX_FILES_BUCKET;

    if (this.action.uploadedImage) {
      this.logo = this.action.uploadedImage;
    } else if (this.action.logo) {
      this.logo = `${logoUrl}/${this.action.logo}`;
    } else {
      this.logo = `${logoUrl}/${this.company.logo}`;
    }

    if (this.action.privacyPolicy) {
      this.linkprivacyPolicy = `${process.env.INDECX_FILES_BUCKET}/privacy-policy/${this.company.privacyPolicy}`;
    }

    if (this.action.email.template.enableMyHTMLPt) {
      this.langView = 'br';
      this.question = this.action.question;
      this.questionHTML = this.action.questionHTML;
      this.myHTML = this.action.email.template.myHTML;
    } else if (this.action.email.template.enableMyHTMLEn) {
      this.langView = 'us';
      this.question = this.action.questionEn;
      this.questionHTML = this.action.questionHTMLEn;
      this.myHTML = this.action.email.template.myHTMLEn;
    } else if (this.action.email.template.enableMyHTMLEs) {
      this.langView = 'es';
      this.question = this.action.questionEs;
      this.questionHTML = this.action.questionHTMLEs;
      this.myHTML = this.action.email.template.myHTMLEs;
    } else {
      this.langView = 'br';
      this.question = this.action.question;
      this.questionHTML = this.action.questionHTML;
      this.myHTML = this.action.email.template.myHTML;
    }
  },

  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },

    showHiddenQuestion(index) {
      if (this.promotersGrades.includes(this.testNpsReview)) {
        this.action.email.additionalQuestions[index].display = false;
        return true;
      } else if (this.detractorsGrades.includes(this.testNpsReview)) {
        this.action.email.additionalQuestions[index].display = false;
        return true;
      } else if (this.passivesGrades.includes(this.testNpsReview)) {
        this.action.email.additionalQuestions[index].display = false;
        return true;
      }

      return false;
    },

    exportPdfResearch() {
      const text = 'download de ação da indecx';
      const myDiv = document.getElementById('div-print');
      const options = {
        allowTaint: true,
        scale: 2,
        useCORS: true,
        scrollX: 0,
        scrollY: -window.scrollY,
      };
      Html2canvas(myDiv, options).then((canvas) => {
        // Reduz a resolução da imagem do canvas em 50%
        const imgData = canvas.toDataURL('image/png', 0.5);
        const pdf = new JsPdf({
          orientation: canvas.width > canvas.height ? 'l' : 'p',
          unit: 'pt',
          format: [canvas.width, canvas.height],
        });
        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
        pdf.setFontSize(10.0);
        pdf.setTextColor(115, 115, 115);
        pdf.setFontType('bold');
        // pdf.text(text, 15, 20);
        pdf.save('indecx.pdf');
      });
    },

    setLangView(locale) {
      this.langView = locale;

      if (this.langView === 'br') {
        this.question = this.action.question;
        this.questionHTML = this.action.questionHTML;
        this.myHTML = this.action.email.template.myHTML;
        this.closingMessage.html = this.actionClosingMessage.default.html;
      }
      if (this.langView === 'us') {
        this.question = this.action.questionEn;
        this.questionHTML = this.action.questionHTMLEn;
        this.myHTML = this.action.email.template.myHTMLEn;
        this.closingMessage.html = this.actionClosingMessage.default.htmlEn;
      }
      if (this.langView === 'es') {
        this.question = this.action.questionEs;
        this.questionHTML = this.action.questionHTMLEs;
        this.myHTML = this.action.email.template.myHTMLEs;
        this.closingMessage.html = this.actionClosingMessage.default.htmlEs;
      }
    },

    isVisible(item, value) {
      if (item.logicalRuleEnabled && item.conditionalRule) {
        let res = false;
        switch (item.conditionalRule) {
          case 'equal': // igual
            if (item.type === 'MULTIPLE') {
              if (!value.isMultipleChoiceCustom) {
                if (item.multipleType === 'radio') {
                  value.multipleValues = this.returnTextInBr(item.choices, value.multipleValues);

                  res =
                    value.multipleValues === item.conditionalValue
                      ? true
                      : false;
                } else {
                  res = value.multipleValues.includes(item.conditionalValue);
                }
              }

              if (value.isMultipleChoiceCustom) {
                if (value.options && value.options.length > 0) {
                  for (let i = 0; i < value.options.length; i += 1) {
                    if (value.options[i].text === item.conditionalValue) {
                      res = true;
                      break;
                    }
                  }
                }
              }
            } else {
              res =
                Number(value.review) === item.conditionalValue ? true : false;
            }
            break;

          case 'differentThan': // diferente
            if (item.type === 'MULTIPLE') {
              if (!value.isMultipleChoiceCustom) {
                if (item.multipleType === 'radio') {
                  value.multipleValues = this.returnTextInBr(item.choices, value.multipleValues);

                  res =
                    value.multipleValues !== item.conditionalValue
                      ? true
                      : false;
                } else {
                  res = value.multipleValues.includes(item.conditionalValue);
                }
              }

              if (value.isMultipleChoiceCustom) {
                if (value.options && value.options.length > 0) {
                  for (let i = 0; i < value.options.length; i += 1) {
                    if (value.options[i].text !== item.conditionalValue) {
                      res = true;
                      break;
                    }
                  }
                }
              }
            } else {
              res =
                Number(value.review) !== item.conditionalValue ? true : false;
            }
            break;

          case 'biggerThen': // maior que
            res = value.review > item.conditionalValue ? true : false;
            break;

          case 'greaterOrEqualTo': // maior ou igual
            res = value.review >= item.conditionalValue ? true : false;
            break;

          case 'lessThan': // menor que
            res = value.review < item.conditionalValue ? true : false;
            break;

          case 'lessThanOrEqualTo': // menor ou igual
            res = value.review <= item.conditionalValue ? true : false;
            break;

          default:
            break;
        }
        return res;
      }
      return false;
    },

    returnTextInBr(array, itemSelected) {
      let text;
      for (let index = 0; index < array.length; index+=1) {
        if (array[index].text === itemSelected || array[index].textEN === itemSelected || array[index].textES === itemSelected) {
           text = array[index].text;
        }
      }
      return text;
    },

    getReview(value) {
      const index = Number(value.position);
      const item = this.action.email.additionalQuestions[index];

      let gradeQuestion = null;

      if (item && item.type && item.type !== 'MULTIPLE' && item.type !== 'INPUT') {
        gradeQuestion = value.review;
      } else if (item && item.type && item.type === 'INPUT') {
        gradeQuestion = value.review ? value.review : value;
        this.researchInfo.additionalQuestions[index].answerText = value.review
          ? value.review
          : value;
      } else {
        gradeQuestion = value.multipleValues;
      }

      if (item && item.idsDisabled && item.idsDisabled.length > 0) {
        item.idsDisabled.forEach((el) => {
          for (
            let i = 0;
            i < this.action.email.additionalQuestions.length;
            i += 1
          ) {
            if (this.action.email.additionalQuestions[i].id === el && value.review !== -1) {
              this.action.email.additionalQuestions[i].show = this.isVisible(
                item,
                value,
              );

              if (
                !this.action.email.additionalQuestions[i].show
              ) {
                this.action.email.additionalQuestions[i].display = false;
              } else {
                this.action.email.additionalQuestions[i].display = true;
              }
            } else {
              // this.action.email.additionalQuestions[i].display = false;
            }
          }
        });
      }

      const arr = this.action.email.additionalQuestions;
      this.action.email.additionalQuestions = [];
      this.action.email.additionalQuestions = arr;
    },

    conditionalQuestion() {
      if (this.promotersGrades.includes(this.testNpsReview)) {
        return 'promotor';
      } else if (this.detractorsGrades.includes(this.testNpsReview)) {
        return 'detrator';
      }

      return 'neutro';
    },

    handleClosingMessage() {
      if (this.action.closingMessageEnabled && this.actionClosingMessage) {
        if (this.actionClosingMessage.dynamic) {
          if (
            this.actionClosingMessage.promoters &&
            this.promotersGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo =
              this.actionClosingMessage.promoters.useLogo;
            this.closingMessage.html = this.actionClosingMessage.promoters.html;
          } else if (
            this.actionClosingMessage.passives &&
            this.passivesGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo =
              this.actionClosingMessage.passives.useLogo;
            this.closingMessage.html = this.actionClosingMessage.passives.html;
          } else if (
            this.actionClosingMessage.detractors &&
            this.detractorsGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo =
              this.actionClosingMessage.detractors.useLogo;
            this.closingMessage.html =
              this.actionClosingMessage.detractors.html;
          }
        } else if (this.actionClosingMessage.default) {
          this.closingMessage.useLogo =
            this.actionClosingMessage.default.useLogo;
          this.closingMessage.html = this.actionClosingMessage.default.html;

          if (this.langView === 'us') {
            this.closingMessage.html = this.actionClosingMessage.default.htmlEn;
          } else if (this.langView === 'es') {
            this.closingMessage.html = this.actionClosingMessage.default.htmlEs;
          }
        }
      }

      this.displayClosingMessage = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapp {
  background-color: $gray-lighter;
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  overflow: auto;
}

.goback {
  float: left;
  margin: 10px;
}

.container {
  background-color: #fff;
  min-height: 100vh;
}

.logo-area {
  img {
    height: 75px;
  }
}

.closing-message-area {
  display: flex;
  flex-direction: column;

  i {
    font-size: 92px;
    color: #009bdb;
  }

  h4 {
    color: #009bdb;
  }
}
.question {
  font-size: 1.1rem;
}
</style>

<style>
.html-content img {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/preview/index.vue